import { render, staticRenderFns } from "./articleSingle.vue?vue&type=template&id=e827dd92"
import script from "./articleSingle.vue?vue&type=script&lang=js"
export * from "./articleSingle.vue?vue&type=script&lang=js"
import style0 from "./articleSingle.vue?vue&type=style&index=0&id=e827dd92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports